import $ from 'zepto'
import ua from 'ua'
import hosts from 'hosts'
import { query } from 'qs'
import cookie from 'cookie'

const $bottombar = $('.layout-bottom-bar')
const $body = $('body')
const noAppLink = cookie.get('noAppLink') || query.noAppLink

$bottombar.attr('href', `http://${hosts.pageHost()}/appDownload.html`)

if (query.noAppLink) {
  cookie.set('noAppLink', 1)
}

if (noAppLink) {
  $body.addClass('no-app-link')
}

if (ua.isPiaoniu()) {
  $body.addClass('piaoniu')
}

if (ua.isMiniProgram()) {
  $body.addClass('miniapp')
}

if (ua.isPiaoniu() || noAppLink) {
  $bottombar.hide()
} else {
  $bottombar.show()
}



// WEBPACK FOOTER //
// ./src/common/bottombar.js